export const ROUTE_MAP: Record<string, string> = {
  "CategoriaGastos": "/categoria-gastos",
  "ChartEmpleadosDept": "/chart-empleados-dept",
  "ChartGastosCat": "/chart-gastos-cat",
  "ChartVentasMes": "/chart-ventas-mes",
  "ChartVentasProducto": "/chart-ventas-producto",
  "Clientes": "/clientes",
  "Consola": "/consola",
  "DashboardGastos": "/dashboard-gastos",
  "DashboardPersonal": "/dashboard-personal",
  "DashboardVentas": "/dashboard-ventas",
  "Departamentos": "/departamentos",
  "DetalleCliente": "/detalle-cliente",
  "DetalleEmpleado": "/detalle-empleado",
  "DetalleGasto": "/detalle-gasto",
  "DetalleProducto": "/detalle-producto",
  "DetalleVenta": "/detalle-venta",
  "DetalleVentas": "/detalle-ventas",
  "Empleados": "/empleados",
  "EntradaApp": "/entrada-app",
  "EntradaAppWeb": "/entrada-app-web",
  "Gastos": "/gastos",
  "ListaClientes": "/lista-clientes",
  "ListaDepartamentos": "/lista-departamentos",
  "ListaEmpleados": "/lista-empleados",
  "ListaGastos": "/lista-gastos",
  "ListaProductos": "/lista-productos",
  "ListaVentas": "/lista-ventas",
  "Login": "/login",
  "LoginWeb": "/login-web",
  "MenuPrincipal": "/menu-principal",
  "MenuPrincipalWeb": "/menu-principal-web",
  "Productos": "/productos",
  "Ventas": "/ventas",
  "WebTestComponents": "/web-test-components",
  "WebTestLayout": "/web-test-layout",
  "Empresas": "/empresas",
  "Usuarios": "/usuarios",
} as const;
